import "./App.css";
import { BrowserRouter } from "react-router-dom";

import ErrorToast from "./components/toast/ErrorToast";
import SessionExpiryHandler from "./components/auth/SessionExpiryHandler";
import Header from "./components/layout/header/Header";
import Footer from "./components/layout/Footer";
import AppRoutes from "./routes/AppRoutes";

import { useGlobalCartSync } from "./hooks/useGlobalCartSync";
import { useWarehouseInitialization } from "./hooks/useWarehouseInitialization";

function App() {
  useGlobalCartSync();
  useWarehouseInitialization();

  return (
    <BrowserRouter>
      <SessionExpiryHandler />
      <ErrorToast />
      <Header />
      <main className="md:py-16 pb-16"> {/* Добавляем отступ снизу для учета высоты футера */}
        <AppRoutes />
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;